module.exports = __webpack_public_path__ + "media/images/icons/sand-6dfae331e8f0e39b1bebeb23321dca2a.svg";